/* NOT TOYS 2026 · the size guide sheet and the to-scale ink drawings (shop, search and product pages).
   Ported from the finished preview (drawRow, sgItems, drawSG, openSG). Heights and drawings come from nt-data.json
   (images in Shopify Files). Any [data-sg] button opens the sheet: "all", or "mine" on a product page.
   Exposes window.NTSG = { ready, url, row, piece, ref, open } for nt-shop.js and nt-product.js. */
(() => {
  if (window.NTSG) return;
  const $ = (id) => document.getElementById(id);
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const host = document.querySelector('.ns[data-src]');
  let D = null;
  const ready = host ? fetch(host.dataset.src, { credentials: 'omit' }).then((r) => (r.ok ? r.json() : null)).catch(() => null).then((d) => { D = d && d.p ? d : null; return D; }) : Promise.resolve(null);
  const url = (n, w) => (D ? D.base : '') + 'nt26-' + String(n).padStart(3, '0') + (n >= 790 ? '.png' : '.jpg') + (w ? `?width=${w}` : '');
  const iw = (w) => Math.min(1080, Math.max(120, Math.ceil((w * Math.min(2, devicePixelRatio || 1)) / 60) * 60));
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const GROUPS = {
    desk: { name: 'Desk', refs: ['cup'], grid: 5, maxH: 30 },
    shelf: { name: 'Shelf', refs: ['vase', 'cup'], grid: 10, maxH: 42 },
    floor: { name: 'Floor', refs: ['chair', 'person'], grid: 25, maxH: 172 },
    object: { name: 'Objects', refs: ['cup', 'book'], grid: 5, maxH: 30 },
    charm: { name: 'Charms', refs: ['cup'], grid: 5, maxH: 30 }
  };
  // F23: a short name for the drawing; the table keeps the full name
  const sgName = (e) => String(e.short || e.n).replace(/\s+-\s+/g, ' ').replace(/\s+Edition$/i, '').replace(/Sea ?[Gg]ull/g, 'Scout');
  const piece = (h, extra) => { const e = D && D.p[h]; if (!e || !e.h || !e.ill) return null; return Object.assign({ f: e.ill[0], h: e.h, w: e.h * e.ill[1], handle: h }, extra || {}); };
  const ref = (k, extra) => { const r = D && D.refs[k]; if (!r) return null; return Object.assign({ f: r.f, h: r.h, w: r.h * r.ar, ref: true, key: k, label: r.l, sub: `${r.h} cm` }, extra || {}); };

  // a row of ink drawings at their true relative size (k = px per cm)
  function row(el, items, o) {
    items = items.filter(Boolean);
    const W = o.fit ? el.clientWidth : el.parentElement.clientWidth, H = el.clientHeight;
    if (!W || !H || !items.length) return 0;
    const cap = o.cap || 0, head = o.head || 0, gap = o.gap || 8, pad = o.pad || 0, slot = o.slot || 0;
    const maxH = o.maxH || Math.max(...items.map((i) => i.h));
    let k = (H - cap - head) / maxH;
    if (o.fit) k = Math.min(k, (W - pad * 2 - gap * (items.length - 1)) / items.reduce((s, i) => s + i.w, 0));
    const slots = items.map((i) => Math.max(i.w * k, slot));
    const total = slots.reduce((s, v) => s + v, 0) + gap * (items.length - 1);
    let x = Math.max(pad, (W - total) / 2);
    let html = '';
    if (o.lines) for (let v = o.lines; v <= maxH + 0.01; v += o.lines) html += `<i class="ns-gridl" style="bottom:${cap + v * k}px"><span>${v} cm</span></i>`;
    if (o.base) html += `<i class="ns-base" style="bottom:${cap}px"></i>`;
    html += items.map((it, n) => {
      const w = it.w * k, h = it.h * k, s = slots[n];
      const vis = `<img class="ns-vis ns-ill" src="${url(it.f, iw(Math.max(w, h * 0.6)))}" alt="" style="width:${w}px;height:${h}px;bottom:${cap}px" decoding="async" loading="lazy">`;
      const label = cap && it.label ? `<span class="ns-rc" style="top:${H - cap}px"><b>${esc(it.label)}</b>${it.sub ? `<span>${esc(it.sub)}</span>` : ''}</span>` : '';
      const cls = `ns-ri${it.ref ? ' ns-ref' : ''}${o.focus && it.handle && it.handle !== o.focus ? ' ns-muted' : ''}`;
      const tag = it.handle && o.pick ? 'button' : 'div';
      const out = `<${tag} class="${cls}" style="left:${x}px;width:${s}px;--dd:${(n * 0.08).toFixed(2)}s"${it.handle ? ` data-h="${esc(it.handle)}"` : ''}${tag === 'button' ? ` type="button" aria-label="${esc(it.label)}, ${esc(it.sub)}"` : ''}>${vis}${label}</${tag}>`;
      x += s + gap;
      return out;
    }).join('');
    el.innerHTML = html;
    if (!o.fit) el.style.width = `${Math.max(x - gap + pad, el.parentElement.clientWidth)}px`;
    return k;
  }
  const drawIn = (box) => { box.classList.remove('ns-drawn'); requestAnimationFrame(() => requestAnimationFrame(() => box.classList.add('ns-drawn'))); };

  // ---------- the sheet
  const sh = $('nsSG');
  let tab = 'all', focus = null, opener = null;
  const bySize = () => Object.keys(D.p).filter((h) => D.p[h].h && D.p[h].ill).sort((a, b) => D.p[a].h - D.p[b].h);
  const groupOf = (g) => {
    const def = GROUPS[g]; if (!def) return null;
    const ids = bySize().filter((h) => D.p[h].g === g);
    const hi = ids.length ? D.p[ids[ids.length - 1]].h : 0;
    return Object.assign({}, def, { ids, maxH: Math.max(def.maxH, Math.ceil(hi + 2)) });
  };
  const items = (t) => {
    const all = bySize();
    if (t === 'all') {
      const tallest = all.length ? D.p[all[all.length - 1]].h : 100;
      return { items: [ref('cup'), ...all.map((h) => piece(h, { label: sgName(D.p[h]), sub: D.p[h].sz })), ref('chair')], lines: 25, maxH: Math.max(104, Math.ceil(tallest + 2)) };
    }
    const g = groupOf(t);
    const refs = g.refs.map((r) => ref(r));
    const ps = g.ids.map((h) => piece(h, { label: sgName(D.p[h]), sub: D.p[h].sz }));
    return { items: t === 'floor' ? [refs[0], ...ps, refs[1]] : [refs[0], ...ps, ...refs.slice(1)], lines: g.grid, maxH: g.maxH };
  };
  const draw = () => {
    if (!sh || !D) return;
    const { items: list, lines, maxH } = items(tab);
    const stage = $('nsSgStage');
    const wide = tab === 'all' || list.length > 7;
    if (!wide) stage.style.width = '';
    row(stage, list, { cap: 64, head: 26, gap: wide ? 16 : 12, pad: wide ? 46 : 40, slot: wide ? 82 : 62, maxH, lines, base: true, pick: true, focus, fit: !wide });
    $('nsSgHint').textContent = wide ? `Lines every ${lines} cm · swipe to see all` : `Lines every ${lines} cm`;
    $('nsSgTabs').querySelectorAll('button').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.t === tab)));
    const f = focus && D.p[focus];
    $('nsSgPick').innerHTML = f ? `<div><b>${esc(f.n)}</b><br><span>${esc(f.sz)} tall${f.wd ? ` · ${esc(f.wd)} wide and deep` : ''}</span></div><a class="ns-btn ns-ghost" href="${root}products/${esc(focus)}">See it</a>` : '<span>Tap any piece to see its measurements.</span>';
    $('nsSgTable').innerHTML = '<tr><th>Piece</th><th>Height</th><th>Lives on</th></tr>' + bySize().map((h) => { const e = D.p[h]; return `<tr class="${h === focus ? 'ns-on' : ''}"><td>${esc(e.n)}</td><td>${esc(String(e.sz).replace(' cm', ''))}</td><td>${(GROUPS[e.g] || { name: '' }).name}</td></tr>`; }).join('');
    drawIn(stage);
  };
  const open = (which, h) => {
    if (!sh) return;
    ready.then(() => {
      if (!D) return;
      focus = h && D.p[h] && D.p[h].h ? h : null;
      tab = which === 'mine' && focus && GROUPS[D.p[focus].g] ? D.p[focus].g : 'all';
      opener = document.activeElement;
      sh.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        sh.classList.add('ns-open'); draw();
        const b = focus && $('nsSgStage').querySelector(`[data-h="${CSS.escape(focus)}"]`), sc = $('nsSgScroll');
        if (b) sc.scrollLeft = Math.max(0, b.offsetLeft + b.offsetWidth / 2 - sc.clientWidth / 2);
        const x = sh.querySelector('.ns-sh-x'); if (x) x.focus({ preventScroll: true });
      });
    });
  };
  const close = () => { if (!sh || sh.hidden) return; sh.classList.remove('ns-open'); document.documentElement.style.overflow = ''; setTimeout(() => { sh.hidden = true; }, reduce ? 0 : 450); if (opener && opener.focus) opener.focus({ preventScroll: true }); };
  if (sh) {
    $('nsSgTabs').innerHTML = [['all', 'All'], ['desk', 'Desk'], ['shelf', 'Shelf'], ['floor', 'Floor']].map(([k, n]) => `<button type="button" data-t="${k}">${n}</button>`).join('');
    $('nsSgTabs').addEventListener('click', (e) => { const b = e.target.closest('button'); if (b) { tab = b.dataset.t; draw(); $('nsSgScroll').scrollLeft = 0; } });
    $('nsSgStage').addEventListener('click', (e) => { const b = e.target.closest('button.ns-ri'); if (b) { focus = b.dataset.h; const cur = $('nsSgScroll').scrollLeft; draw(); $('nsSgScroll').scrollLeft = cur; } });
    sh.addEventListener('click', (e) => { if (e.target.closest('[data-close]')) close(); });
    addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    let rt; addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(() => { if (!sh.hidden) draw(); }, 140); });
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-sg]'); if (!b || !b.closest('.ns')) return;
    e.preventDefault();
    const p = document.getElementById('nsP');
    open(b.dataset.sg, p ? p.dataset.handle : null);
  });
  window.NTSG = { ready, url, iw, row, piece, ref, groupOf, sgName, drawIn, open, close, get data() { return D; } };
})();
